export default __webpack_public_path__ + "static/media/4-min.e57f8b80.jpg";